import { LimitedCompanyScreen } from './LimitedCompanyScreen';

/** Angular LimitedcompanyFRS105Component: `/home/settings/limited-company-FRS105` (no lightbulb). */
export function LimitedcompanyFRS105() {
  return <LimitedCompanyScreen settingsKey="limited-frs105" padded />;
}
